module.exports = __webpack_public_path__ + "static/img/increment02.dd00ac7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/increment02.png
// module id = +wDF
// module chunks = 0